export default class DayPartsService {
  dayParts = [];
  onChangeHandlers = [];

  constructor(AlertService, Authentication, Utils, SlingApi) {
    'ngInject';
    Object.assign(this, { AlertService, Authentication, Utils, SlingApi });
  }

  async loadFromServer() {
    const dayParts = await this.SlingApi.getDayParts();
    dayParts.forEach((dayPart) => {
      dayPart.dtstart = this.Utils.getRealDate(`2019-01-01T${dayPart.timeStart}`);
      dayPart.dtend = this.Utils.getRealDate(`2019-01-01T${dayPart.timeEnd}`);
    });
    this.dayParts = dayParts;
    return this.dayParts;
  }

  async loadData() {
    if (!this.Authentication.isOrgFeatureEnabled('dayParts')) {
      return false;
    }

    if (!this.promise) {
      this.promise = this.loadFromServer();
    }

    try {
      return await this.promise;
    } catch (error) {
      this.promise = null;

      throw error;
    }
  }

  notifyOnChange() {
    this.onChangeHandlers.forEach((h) => h());
  }

  onChange(handler) {
    this.onChangeHandlers.push(handler);
    const controller = this;

    return function deregisterOnChange() {
      const index = controller.onChangeHandlers.indexOf(handler);
      if (index >= 0) {
        controller.onChangeHandlers.splice(index, 1);
      }
    };
  }

  // eslint-disable-next-line no-dupe-class-members
  get dayParts() {
    return this.dayParts.map((d) => ({ ...d }));
  }

  async saveBulk(payload) {
    const response = await this.SlingApi.dayPartsBulk(
      payload.map((item) => ({
        ...item,
        timeStart: this.Utils.formatTime(item.dtstart),
        timeEnd: this.Utils.formatTime(item.dtend),
      }))
    );

    delete this.promise;
    return response;
  }

  async addDayPart(dayPart) {
    const newDayPart = {
      ...dayPart,
      timeStart: this.Utils.formatTime(dayPart.dtstart),
      timeEnd: this.Utils.formatTime(dayPart.dtend),
    };

    const [{ id }] = await this.saveBulk([newDayPart]);
    this.dayParts.push({
      ...newDayPart,
      id,
    });
    this.notifyOnChange();
    this.AlertService.success('Successfully created day part');
  }

  async editDayPart(dayPart, updatedDayPart) {
    const index = this.dayParts.indexOf(dayPart);
    if (index >= 0) {
      const updatedDayPartWithTime = {
        ...updatedDayPart,
        timeStart: this.Utils.formatTime(updatedDayPart.dtstart),
        timeEnd: this.Utils.formatTime(updatedDayPart.dtend),
      };

      await this.saveBulk([updatedDayPartWithTime]);
      this.dayParts[index] = updatedDayPartWithTime;
      this.notifyOnChange();
      this.AlertService.success('Successfully edited day part');
    }
  }

  async deleteDayPart(dayPartToDelete) {
    const index = this.dayParts.findIndex((dayPart) => dayPart.id === dayPartToDelete.id);

    if (index >= 0) {
      dayPartToDelete.deleted = true;
      await this.saveBulk([dayPartToDelete]);
      this.dayParts.splice(index, 1);
      this.notifyOnChange();
      this.AlertService.success('Successfully deleted day part');
    }
  }
}
